export default __webpack_public_path__ + "static/media/lendnest1.f22074e6.png";